import type { ControllerFieldState } from 'react-hook-form';
import { forwardRef } from 'react';
import { useFormContext } from 'react-hook-form';

import type { TextFieldProps } from '../../../../Toolkit/Inputs/TextField';
import { TextField } from './FinanceTextField.styled';
import { preventSubmit } from '../preventSubmit';

type FinanceTextFieldProps = Omit<
  TextFieldProps,
  'hasError' | 'errorMessage' | 'name'
> &
  ControllerFieldState & { name: string; isOptional?: boolean };

export const FinanceTextField = forwardRef<
  HTMLInputElement,
  FinanceTextFieldProps
>((props, ref) => {
  const { invalid, value, onFocus, ...rest } = props;
  const { clearErrors } = useFormContext();
  return (
    <TextField
      {...rest}
      hasError={invalid}
      errorMessage={props.error?.message}
      ref={ref}
      value={value}
      onKeyPress={preventSubmit}
      onFocus={() => {
        clearErrors(props.name);
        onFocus?.();
      }}
    />
  );
});

FinanceTextField.displayName = 'FinanceTextField';
